export default {
  props: {
    noCenter: {
      type: Boolean,
      default: false,
    },
  },
}
